import { Paper, makeStyles } from '@material-ui/core';
import React from 'react';
import Carousel from 'react-material-ui-carousel';
import ChartClasses from '../reports/components/ChartClasses';
import SignalsSlide from '../assets/signals-ss.png';
import PatternsSlide from '../assets/patterns-ss.png';
import ReportsSlide from '../assets/reports-ss.png';
const styles = makeStyles(theme => ({
	carouselWrapper: {
		height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
	},

    activeIconButton: {
        width: 16,
        height: 16,
        color: "white",
    },

    iconButton: {
        width: 16,
        height: 16,
    }

}));
const LoginCarousel = () => {
    let classes = styles();
    const items = [
        {
            name: "Signals",
            path: SignalsSlide
        },
        {
            name: "Patterns",
            path: PatternsSlide
        },
        {
            name: "Reports",
            path: ReportsSlide
        }
    ];

    return (
        <Carousel className={classes.carouselWrapper}
            activeIndicatorIconButtonProps={{className: classes.activeIconButton}} 
            indicatorIconButtonProps={{className: classes.iconButton}} >
            {items.map((item, i) => (
                <Item key={i} item={item} />
            ))}
        </Carousel>
    );
}

const Item = (props) => {
    return (
        <div style={{textAlign: "center", alignItems:"center"}}>
            <img src={props.item.path} alt={props.item.name} style={{ width: '80%', borderRadius: 8 }} />
        </div>
    );
}

export default LoginCarousel;